import { WizardStep } from "../goals/GoalWizard";

interface WizardProgressProps {
    currentStep: number;
    steps: WizardStep[];
}
const WizardProgress = ({ currentStep, steps }: WizardProgressProps) => (
    <div className="px-6 pt-4 pb-2 flex justify-between">
        {steps.map((s, i) => {
            const StepIcon = s.icon;
            return (
                <div key={i} className="flex flex-col items-center flex-1 relative">
                    <div
                        className={`
                w-10 h-10 rounded-full flex items-center justify-center 
                transition-all duration-300 
                ${i === currentStep
                                ? 'bg-blue-500 text-white scale-110'
                                : i < currentStep
                                    ? 'bg-green-500 text-white'
                                    : 'bg-gray-200 dark:bg-gray-700 text-gray-500 dark:text-gray-400'
                            }
              `}
                    >
                        <StepIcon className="w-5 h-5" />
                    </div>
                    <span
                        className={`text-xs mt-1 ${i === currentStep
                            ? 'font-semibold text-blue-600 dark:text-blue-400'
                            : 'text-gray-500 dark:text-gray-400'
                            }`}
                    >
                        {s.title}
                    </span>
                </div>
            );
        })}
    </div>
);

export default WizardProgress;